













































import Vue from 'vue';
// eslint-disable-next-line
import { eventBus } from '@/main';
import TabLink from '@/modules/site/pages/dashboard/mi-cuenta/TabLink.vue';
import { GeneralAccount, getIdCliente } from '@/models/accounts/GeneralAccount';
import store from '@/services/store';
import msg from '@/services/userMsg';
import Pedido from '@/models/Pedido';
import { INSERVER_BASE_URL } from '@/services/http';
import LoadingFullscreen from '@/modules/LoadingFullscreen.vue';
import PedidosDetail from '../mis-pedidos/PedidosDetail.vue';
import YearReportSelector from '../informes/YearReportSelector.vue';
import PedidosListWFilters from '../mis-pedidos/PedidosListWFilters.vue';

export default Vue.extend({
  name: 'Recorridos',
  components: {
    PedidosDetail,
    PedidosListWFilters,
    YearReportSelector,
    TabLink,
    LoadingFullscreen,
  },
  props: {
    /** Route params */
    q: { type: String, default: '' },
    status: { type: String, default: '' },
    since: { type: String },
    until: { type: String },
    selected: { type: String, default: '-1' },
    modal: { type: String, default: null },
  },
  data() {
    return {
      sectionName: 'recorridos',
      pedidoSelected: undefined as Pedido | undefined,
      isSelected: false,
      currentTab: 0 as number,
      chartLoading: true as boolean,
      selectedYear: new Date().getFullYear(),
    };
  },
  mounted() {
    document.title = `${this.sectionData.title} - InPunto`;
  },
  beforeDestroy() {
    if (this.pedidoSelected) eventBus.$emit('pedidoSelected', false);
  },
  methods: {
    deselectPedido(): void {
      this.$router.replace({
        query: {
          ...this.$route.query,
          selected: undefined,
        },
      });
    },
    handleYearSelected(year: number) {
      this.selectedYear = year;
    },
    updatePedido(): void {
      if (this.pedidoSelected) {
        eventBus.$emit('updatePedido', this.pedidoSelected);
        this.$emit('update');
      }
    },
  },
  computed: {
    isMobile(): boolean {
      return this.$store.getters.isMobile;
    },
    selectedAccount(): GeneralAccount { return store.getters.selectedAccount; },
    selectedClient(): number { return getIdCliente(this.selectedAccount); },
    navbarHeight(): number {
      return this.$store.getters.navbarHeight;
    },
    sectionData(): { title: string, desc: string} {
      const title = msg.getTitle(this.sectionName);
      const desc = msg.getDescription(this.sectionName);
      return {
        title,
        desc,
      };
    },
    recorridosStreamlitURL(): string {
      return `${INSERVER_BASE_URL}streamlit/resumen_recorridos?id_cliente=${this.selectedClient}&year=${this.selectedYear}&embed=true`;
    },
  },
  watch: {
    pedidoSelected(pedido) {
      if (pedido === undefined) {
        this.isSelected = false;
      } else {
        this.isSelected = true;
      }
    },
    currentTab(newTab) {
      if (newTab === 1) {
        this.$router.replace({
          query: {
            ...this.$route.query,
            q: undefined,
            status: undefined,
            since: undefined,
            until: undefined,
            selected: undefined,
            modal: undefined,
          },
        });
        this.deselectPedido();
        this.isSelected = false;
      }
    },
  },
});
